import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component

export default class JsCatalogBannerSlider {
	static classname = 'js-catalog-banner-slider';
	constructor($wrapper) {
		this.$wrapper = $wrapper;

		this.init();
	}

	init() {
		const $sliderWrapper = this.$wrapper;

		new Swiper($sliderWrapper.find('.swiper-container'), {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			speed: 700,
			lazy: true,
			autoplay: {
				delay: 5000
			},
			navigation: {
				nextEl: $sliderWrapper.find('.swiper-button-next'),
				prevEl: $sliderWrapper.find('.swiper-button-prev')
			},
			pagination: {
				el: $sliderWrapper.find('.swiper-pagination'),
				clickable: true
			},
			breakpoints: {
				900: {
					spaceBetween: 15
				}
			}
		});
	}
}
